export default function TruckSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center">
          <div className="w-full max-w-4xl rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://static.readdy.ai/image/9751c2861f77ccab088a483472b903b8/40b63b8a855b584541a93e0ad60a0b2b.png"
              alt="吉川産業 収集車"
              title="吉川産業 収集車"
              className="w-full h-auto object-cover"
            />
          </div>
          <p className="mt-5 md:mt-6 text-center text-foreground-700 text-sm md:text-base leading-relaxed max-w-3xl">
            吉川産業では、事業系ごみ・産業廃棄物の収集運搬に対応しています。地域に密着した迅速な対応で、法人様・店舗様の廃棄物処理をサポートします。
          </p>
        </div>
      </div>
    </section>
  );
}